import { NgModule } from '@angular/core';
import {CommonModule, CurrencyPipe, DecimalPipe} from '@angular/common';
import { AddChargesCreditsComponent } from './components/add-charges-credits/add-charges-credits.component';
import {AgGridModule} from 'ag-grid-angular';
import { CreateChargesCreditsComponent } from './components/create-charges-credits/create-charges-credits.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {Trip2ThemeModule} from '../../../../trip2-theme/trip2-theme.module';
import {ComunicationEditBilling} from './comunication-edit-billing';
import {BillingEditService} from '../../../../core/services/billing-edit.service';
import {TextMaskModule} from 'angular2-text-mask';
import { InfoTripBillingComponent } from './components/info-trip-billing/info-trip-billing.component';
import {MyDatePickerModule} from 'mydatepicker';
import {DirectivesModule} from '../../../../directives/directives.module';
import {RiderModule} from '../../../rider/rider.module';
import {ChangeBillingStatusModule} from '../../../A2-utils/change-billing-status/change-billing-status.module';
import { AutoCompleteDenialCodeModule } from 'app/utils/auto-complete-denial-code/auto-complete-denial-code.module';
import { AutoCompleteDenialCategoryModule } from 'app/utils/auto-complete-denial-category/auto-complete-denial-category.module';

@NgModule({
  imports: [
    CommonModule,
    AgGridModule,
    FormsModule,
    ReactiveFormsModule,
    Trip2ThemeModule,
    TextMaskModule,
    MyDatePickerModule,
    DirectivesModule,
    RiderModule,
    ChangeBillingStatusModule,
    AutoCompleteDenialCodeModule,
    AutoCompleteDenialCategoryModule
  ],
  exports: [
    AddChargesCreditsComponent,
    InfoTripBillingComponent
  ],
  declarations: [AddChargesCreditsComponent, CreateChargesCreditsComponent, InfoTripBillingComponent],
  providers: [ComunicationEditBilling, BillingEditService, CurrencyPipe, DecimalPipe]
})
export class EditBillingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/edit-reservation/edit-billing/edit-billing.module.ts